import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=1203833a&"
import script from "../components/dropdown.vue.ts?vue&type=script&lang=ts&"
export * from "../components/dropdown.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports